import { getDescriptionDetailTextType } from './types';

export const getDescriptionDetailText: getDescriptionDetailTextType = ({
  formatMessage,
  points,
}) => {
  return formatMessage({ id: 'numberOfCrowns' }, { crowns: points });
};
